export const COMMON_LOGIN_MODAL = 'AUTH_MODAL_OPEN';
export const EXTERNAL_REDIRECTION_LOGIN_MODAL =
  'EXTERNAL_REDIRECTION_LOGIN_MODAL';

export const OPEN_GRACE_PERIOD_CANCELLATION_MODAL =
  'open_grace_period_cancellation_modal';
export const OPEN_CHECK_PLACE_24H_MODAL = 'open_check_place_24h_modal';
export const OPEN_LAST_MINUTE_BACKUP_MODAL = 'open_last_minute_backup_modal';
export const OPEN_FULL_SCREEN_PHOTO_LIST = 'open_full_screen_photo_list';
export const OPEN_DEPOSIT_PROTECTION_MODAL = 'open_deposit_protection_modal';
export const OPEN_INSTANT_BOOKING_MODAL = 'open_instant_booking_modal';
export const OPEN_VERIFICATION_MODAL = 'open_verification_modal';
export const FAVORITES_UPDATED = 'favorite_updated';
export const REFRESH_CALENDAR_DATEPICKER = 'refresh_calendar_datepicker';
export const OPEN_EXPOSED_FILTER = 'open_exposed_filter';
export const CLOSE_EXPOSED_FILTER = 'close_exposed_filter';
export const HOMECARD_MAP_OPEN = 'homecard_map_open';
export const HOMECARD_MAP_CLOSE = 'homecard_map_close';
export const OPEN_GUARANTEE_MODAL = 'open_guarantee_modal';
export const GOOGLE_ONE_TAP_SHOWN = 'google_one_tap_shown';
export const GOOGLE_ONE_TAP_HIDDEN = 'google_one_tap_hidden';

export const DELAY_TOAST_IN_MS = 30000;

export const OPEN_MODAL_EVENTS = {
  open: {
    eventCategory: 'signup/login modal',
    eventAction: 'TemporalDiscount',
    eventLabel: 'open'
  },
  close: {
    eventCategory: 'signup/login modal',
    eventAction: 'TemporalDiscount',
    eventLabel: 'close'
  }
};

export const CHANNELS = {
  COMMON_LOGIN_MODAL,
  OPEN_DEPOSIT_PROTECTION_MODAL,
  OPEN_INSTANT_BOOKING_MODAL,
  OPEN_FULL_SCREEN_PHOTO_LIST,
  OPEN_GRACE_PERIOD_CANCELLATION_MODAL,
  OPEN_CHECK_PLACE_24H_MODAL,
  OPEN_LAST_MINUTE_BACKUP_MODAL,
  OPEN_GUARANTEE_MODAL,
  OPEN_VERIFICATION_MODAL,
  REFRESH_CALENDAR_DATEPICKER,
  OPEN_EXPOSED_FILTER,
  CLOSE_EXPOSED_FILTER,
  HOMECARD_MAP_OPEN,
  HOMECARD_MAP_CLOSE,
  GOOGLE_ONE_TAP_SHOWN,
  GOOGLE_ONE_TAP_HIDDEN
};
